import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { createEntity, getEntity, reset, updateEntity } from './merchant.reducer';

export const MerchantUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const merchantEntity = useAppSelector(state => state.merchant.entity);
  const loading = useAppSelector(state => state.merchant.loading);
  const updating = useAppSelector(state => state.merchant.updating);
  const updateSuccess = useAppSelector(state => state.merchant.updateSuccess);

  const handleClose = () => {
    navigate(`/merchant${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...merchantEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...merchantEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tycheApp.merchant.home.createOrEditLabel" data-cy="MerchantCreateUpdateHeading">
            <Translate contentKey="tycheApp.merchant.home.createOrEditLabel">Create or edit a Merchant</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="merchant-id"
                  label={translate('tycheApp.merchant.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('tycheApp.merchant.name')} id="merchant-name" name="name" data-cy="name" type="text" />
              <ValidatedField
                label={translate('tycheApp.merchant.imagePath')}
                id="merchant-imagePath"
                name="imagePath"
                data-cy="imagePath"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.merchant.coverPhoto')}
                id="merchant-coverPhoto"
                name="coverPhoto"
                data-cy="coverPhoto"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.merchant.category')}
                id="merchant-category"
                name="category"
                data-cy="category"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.merchant.description')}
                id="merchant-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/merchant" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MerchantUpdate;
